<template>
  <div class="esport-page-container">
    <div class="left-box">
      <div
        class="banner"
        :style="{
          backgroundImage:
            curBanner && curBanner.image ? `url(${curBanner.image})` : '',
        }"
        @click="bannerJump"
      ></div>
      <div class="video-news-box">
        <div class="video-box">
          <div class="box-title">
            {{ getPageDict(5) /* 最新赛事 */ }}
          </div>
          <div class="box-body">
            <div
              class="video-image"
              v-if="curVideo"
              :style="{
                backgroundImage: `url(${curVideo.thumbnailMedium})`,
              }"
              @click="gotoVideo(curVideo.id)"
            ></div>
          </div>
          <div class="bottom-splint-box"></div>
        </div>
        <div class="news-box">
          <div class="box-title">
            {{ getPageDict(6) /* 战队资讯 */ }}
          </div>
          <div class="box-body" v-scroll-down-to-get-data="getNextPageNews">
            <div class="news-list">
              <div
                class="news-item"
                v-for="(news, index) in newsList"
                :key="index"
                @click="gotoESportNews(news._id)"
              >
                <span class="title">{{ news.title }}</span>
                <span class="time">{{
                  news.updatedAt | formatDate("MM-DD")
                }}</span>
              </div>
            </div>
          </div>
          <div class="bottom-splint-box"></div>
        </div>
      </div>
    </div>
    <div class="club-video-box">
      <div class="box-title">
        {{ getPageDict(7) /* 视频中心 */ }}
      </div>
      <div class="box-body" v-scroll-down-to-get-data="getNextPageClubVideo">
        <div class="club-video-list">
          <div
            class="club-video-item"
            v-for="(clubVideo, index) in clubVideoList"
            :key="index"
            @click="gotoClubVideo(clubVideo)"
          >
            <div
              class="image"
              :style="{
                backgroundImage: `url(${clubVideo.thumbnailMedium})`,
              }"
            ></div>
            <div class="video-info">
              <div class="video-title">{{ clubVideo.title }}</div>
              <div class="video-streamer">{{ clubVideo.streamer }}</div>
              <div class="video-view-count">
                {{ clubVideo.viewCount | readableNum
                }}{{ getPageDict(8) /* 播放量 */ }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDict, getPageDictInit, invokeNative, axios, bus } from "@/common";
import { mapState, mapGetters } from "vuex";
import store from "@/store";
import AutoTitle from "@/components/autoTitle";
const getPageDict = getPageDictInit("eSport");

export default {
  name: "eSportIndex",
  // mixins: [getPageLevelMixin],
  components: {
    AutoTitle,
  },
  props: {},
  data() {
    return {
      // bannerList: [],
      // videoList: [],

      // clubVideoList: [],
      // hasNextClubVideo: true,
      // newsList: [],
      // hasNextNews: true,

      timeStep: 0,
    };
  },
  computed: {
    ...mapState({
      bannerList: (state) => state.eSportPage.bannerList,
      videoList: (state) => state.eSportPage.videoList,
      clubVideoList: (state) => state.eSportPage.clubVideoList,
      newsList: (state) => state.eSportPage.newsList,
    }),
    ...mapGetters(["nowTs"]),
    curBanner() {
      for (let banner of this.bannerList) {
        if (!banner.endTime || banner.endTime >= this.timeStep) {
          return banner;
        }
      }
      return this.bannerList[this.bannerList.length - 1];
    },
    curVideo() {
      for (let video of this.videoList) {
        if (!video.endTime || video.endTime >= this.timeStep) {
          return video;
        }
      }
      return this.videoList[this.videoList.length - 1];
    },
  },
  watch: {},
  methods: {
    getDict,
    getPageDict,
    getNextPageNews() {
      store.dispatch("eSportPage/getNextPageNews");
    },
    getNextPageClubVideo() {
      store.dispatch("eSportPage/getNextPageClubVideo");
    },
    bannerJump() {
      if (!this.curBanner || !this.curBanner.jumpData) {
        return;
      }
      /* 
      video: "视频",
      club: "俱乐部",
      clubLive: "俱乐部Live",
      eShopNews: "eShop资讯", 
      */
      switch (this.curBanner.jumpType) {
        case "video":
          this.gotoVideo(this.curBanner.jumpData);
          break;
        case "club":
          this.gotoClubPage(this.curBanner.jumpData);
          break;
        case "clubLive":
          this.gotoClubLivePage(this.curBanner.jumpData);
          break;
        case "eShopNews":
          this.gotoESportNews(this.curBanner.jumpData);
          break;

        default:
          break;
      }
    },
    gotoVideo(videoId) {
      this.$router.push(`/video/${videoId}`);
    },
    async gotoClubPage(clubId) {
      await this.$store.dispatch("clubPage/switchCurClub", clubId);
      this.$emit("switchTab", "club");
    },
    async gotoClubLivePage(clubId) {
      await this.$store.dispatch("clubPage/switchCurClub", clubId);
      this.$emit("switchTab", "live");
    },
    async gotoClubVideo(clubVideo) {
      await this.gotoClubLivePage(clubVideo.linkClubId);
      this.$nextTick(() => {
        this.$nextTick(() => {
          //2个$nextTick 提高live页面已经加载好的概率
          bus.$emit("setClubVideoId", clubVideo.videoId);
        });
      });

      // linkClubId;
    },
    gotoESportNews(id) {
      this.$emit("switchTab", "news");
      this.$nextTick(() => {
        this.$nextTick(() => {
          //2个$nextTick 提高live页面已经加载好的概率
          bus.$emit("showESportNewsId", id);
        });
      });
    },
  },
  mounted() {},
  created() {
    this.timeStep = this.nowTs;
    store.dispatch("eSportPage/getIndexDataWhileNeed");
  },
};
</script>

  <style lang="scss" scoped>
/* 定义$page-nav-height */
@import "../../comps/nav/index.scss";
.esport-page-container {
  $page-container-margin-top: 0.12rem;
  height: 0;
  flex: 1;
  margin-top: $page-container-margin-top;
  display: flex;

  .box-title {
    $height: 0.61rem;
    $margin-bottom: -0.1rem;
    width: 100%;
    height: $height;
    margin-bottom: $margin-bottom;
    color: #292829;
    line-height: $height;
    font-size: 0.22rem;
    font-weight: 600;
    text-align: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .left-box {
    width: 8.24rem;
    display: flex;
    flex-direction: column;
    // border: 1px solid #f00;

    .banner {
      width: 100%;
      flex: 1;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
    }

    .video-news-box {
      margin-top: 0.1rem;
      height: 2.3rem;
      width: 100%;
      display: flex;

      .video-box {
        width: 3.1rem;
        height: 100%;
        display: flex;
        flex-direction: column;
        .box-title {
          background-image: url(./imgs/video-top-bg.png);
        }

        .box-body {
          flex: 1;
          background-color: rgba(#fff, 0.3);
          display: flex;
          justify-content: center;
          align-items: center;

          .video-image {
            width: 2.74rem;
            height: 1.54rem;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }
      .news-box {
        margin-left: 0.1rem;
        flex: 1;
        width: 0;
        height: 100%;
        display: flex;
        flex-direction: column;

        .box-title {
          background-image: url(./imgs/news-top-bg.png);
        }
        .box-body {
          flex: 1;
          flex-shrink: 1;
          background-color: rgba(#fff, 0.3);
          display: flex;
          overflow-y: auto;

          .news-list {
            width: 0;
            flex: 1;
            margin: 0.2rem;
            font-size: 0.16rem;
            color: #292829;

            .news-item {
              width: 100%;
              display: flex;
              height: 0.46rem;
              align-items: center;
              border-top: rgba(#452802, 0.2) solid 0.01rem;
              .title {
                width: 0;
                flex: 1;

                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .time {
                width: 0.7rem;
                text-align: center;
              }
            }
          }
        }
      }
    }
  }

  .club-video-box {
    flex: 1;
    margin-left: 0.2rem;
    display: flex;
    flex-direction: column;
    margin-top: -$page-nav-height - $page-container-margin-top;

    .box-title {
      background-image: url(./imgs/club-video-top-bg.png);
    }
    .box-body {
      background: url(./imgs/club-video-bg.png) no-repeat;
      background-size: 100% 100%;
      flex: 1;
      overflow-y: auto;
      .club-video-list {
        margin: 0.2rem;
        .club-video-item {
          display: flex;
          align-items: center;
          color: #292829;
          &:not(:first-child) {
            margin-top: 0.2rem;
          }
          .image {
            width: 1.86rem;
            height: 1.12rem;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center;
          }
          .video-info {
            width: 0;
            flex: 1;
            margin-left: 0.1rem;
            .video-title {
              font-size: 0.18rem;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-bottom: 0.2rem;
            }
            .video-streamer {
              font-size: 0.14rem;
            }
            .video-view-count {
              font-size: 0.14rem;
            }
          }
        }
      }
    }
  }
}
.bottom-splint-box {
  $margin-bottom: 0.08rem;
  width: 100%;
  height: $margin-bottom;
  display: flex;
  align-items: flex-end;
  &::before {
    content: "";
    flex: 1;
    height: 0.04rem;
    border-bottom: 0.01rem solid rgba(#fff, 0.4);
    margin-right: 0.04rem;
  }
  &::after {
    content: "";
    width: 0.34rem;
    height: 0.04rem;
    background-image: url(../../imgs/box-bottom-splint.png);
    background-size: 100% 100%;
  }
}
</style>
